import React, {Component} from "react";
import "./UserDeleteAddress.css";
import "../../../Common/Common.css";
import {Modal} from "react-bootstrap";
import {FormattedMessage} from "react-intl";
import {RESOURCE_BASE_URL} from "../../../../configuration";
import axios from "axios";

class UserDeleteAddress extends Component {

    constructor(props) {
        super(props);

        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            show: false,
            addressDetails: this.props.addressDetails
        };
    }

    handleClose = () => {
        this.setState({show: false});
    };

    handleShow = () => {
        this.setState({show: true});
    };

    deleteAddress = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.delete(RESOURCE_BASE_URL + 'api/users/' + this.props.userInfo.id +
            '/addresses/' + this.state.addressDetails.id, axiosConfig)
            .then((res) => {
                this.props.getUserAddresses(this.props.userInfo.id);
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });

    };

    onSubmit = event => {

        event.preventDefault();
        this.deleteAddress();
        this.handleClose();
    };

    render() {
    let bothAddressMsg = (this.props.addressDetails.addressType.includes("BILLING") && this.props.addressDetails.addressType.includes("SHIPPING"));
    let billingMsg = this.props.addressDetails.addressType.includes("BILLING");
    let shippingMsg = this.props.addressDetails.addressType.includes("SHIPPING");
    let detailMsg = "";
        return (
            <span>
                <a className="btn btn-xs btn-danger user-table-btn-responsive unify-btn-responsive-user-profile" onClick={this.handleShow}>
                    <FormattedMessage id="app.user-profile.user-delete-address.delete-button-text"
                                      defaultMessage="Delete"
                                      description=""
                    />
                </a>
                <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.user-profile.user-delete-address.title"
                                              defaultMessage="DELETE ADDRESS"
                                              description=""
                            />
                        </div>
                    </Modal.Header>
                    <Modal.Body id="delete-address-error-modal">
                        <div className="color-text">

                            {bothAddressMsg === true ? <text>この住所が請求先住所およびお届け先住所として設定されています。<br/>
                                    住所を削除する前に請求先住所およびお届け先住所として別の住所を設定してください。</text>:
                                billingMsg === true ?<text>この住所が請求先住所およびお届け先住所として設定されています。<br/>
                                        住所を削除する前に請求先住所およびお届け先住所として別の住所を設定してください。</text>:
                                    shippingMsg === true ? <text>この住所が請求先住所およびお届け先住所として設定されています。<br/>
                                            住所を削除する前に請求先住所およびお届け先住所として別の住所を設定してください。</text>:
                                        <FormattedMessage id="app.user-profile.user-delete-address.delete-message"
                                                          defaultMessage="Are you sure you want to delete this address ?"
                                                          description=""
                                        />}

                            <br/>
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="delete-address-div">

                            {bothAddressMsg === true ? <button className="btn btn-warning" onClick={this.handleClose}>閉じる</button> :
                                billingMsg === true ? <button className="btn btn-warning" onClick={this.handleClose}>閉じる</button>:
                                    shippingMsg === true ?  <button className="btn btn-warning" onClick={this.handleClose}>閉じる</button> :
                                        <button className="btn btn-danger bottom-button" onClick={this.onSubmit}>
                                            削除
                                        </button>
                                        }


                        {/*<button className="btn btn-default bottom-button" onClick={this.handleClose}>*/}
                            {/*<FormattedMessage id="app.user-profile.user-delete-address.no-button-text"*/}
                                              {/*defaultMessage="No"*/}
                                              {/*description=""*/}
                            {/*/>*/}
                        {/*</button>*/}
                        </div>
                    </Modal.Footer>
                </Modal>
            </span>
        );
    }
}

export default UserDeleteAddress;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserDeleteAddress/UserDeleteAddress.js